import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import type { AppState } from 'types/app';
import { fireAmplitudeEvent } from 'utils/amplitude';
import { buildAmplitudeEvent } from 'helpers/amplitudeEventBuilders';

interface UseGlobalBannerAmplitudeImpressionParams {
  pageType?: string;
  sessionId: string;
  componentName: string;
  slotName: string;
  creativeId: string;
}

export const useGlobalBannerAmplitudeImpression = ({
  pageType,
  sessionId,
  componentName,
  slotName,
  creativeId
}: UseGlobalBannerAmplitudeImpressionParams) => {
  const isRecognizedCustomer = useSelector((state: AppState) => state.customer);
  const directedID = useSelector((state: AppState) => state.holmes?.directedId ?? undefined);
  const isEnrolledInVip = useSelector((state: AppState) => state.rewards?.rewardsInfo?.enrolled);

  useEffect(() => {
    if (isEnrolledInVip !== undefined) {
      const event = buildAmplitudeEvent({
        event: 'impression',
        pageType,
        sessionId,
        componentName,
        componentType: 'global banner',
        componentContext: 'Header',
        isRecognizedCustomer,
        isEnrolledInVip,
        directedID,
        trackingPayload: {
          slotName,
          creativeId
        }
      });

      fireAmplitudeEvent(event);
    }
  }, [isEnrolledInVip, pageType, sessionId, componentName, slotName, creativeId, isRecognizedCustomer, directedID]);
};
